import { makeAutoObservable } from "mobx"

export class LibraryStore {
  installed: string[] = []
  rootStore

  constructor(rootStore) {
    makeAutoObservable(this, {
      rootStore: false
    })
    this.rootStore = rootStore
  }
}